import { FC, memo, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import { lightScrollbarStyle } from "@/styles/lightScrollbarStyle";

export type FilterPanelProps = {
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  /** Fill the remaining space instead of using a fixed width (e.g. in a modal). */
  fill?: boolean;
};

export const FilterPanel: FC<FilterPanelProps> = memo(
  ({ title, onClose, children, width = 300, fill = false }) => {
    return (
      <Box
        sx={{
          ...(fill
            ? { flex: 1, minWidth: 0 }
            : { width, flexShrink: 0, borderRight: 1 }),
          bgcolor: "background.paper",
          borderColor: "divider",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            aria-label="Close filter panel"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Divider />

        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            p: 2,
            ...lightScrollbarStyle,
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }
);

FilterPanel.displayName = "FilterPanel";
